export const jobBoardsOptions = [
  {
    title: "Work Status",
    placeholder: "Select Work Status",
    alias: "WorkStatus",
    type:"multiSelect",
    options: [
      { label: "Can work for any employer", value: "CTAY" },
      { label: "US Citizen", value: "CTCT" },
      { label: "H1 Visa", value: "CTEM" },
      { label: "Green Card Holder", value: "CTGR" },
      { label: "Need H1 Visa Sponsor", value: "CTNO" },
      { label: "TN Permit Holder", value: "EATN" },
      { label: "Employment Authorization Document", value: "EAEA" },
      { label: "Not specified", value: "CTNS" }
    ],
  },
  {
    title: "Job Categories",
    placeholder: "Select Job Categories",
    alias: "JobCategories",
    type:"select",
    options: [
      { label: "Accounting", value: "JN001" },
      { label: "Admin - Clerical", value: "JN002" },
      { label: "Automotive", value: "JN054" },
      { label: "Banking", value: "JN038" },
      { label: "Biotech", value: "JN053" },
      { label: "Business Development", value: "JN019" },
      { label: "Business Opportunity", value: "JN059" },
      { label: "Construction", value: "JN043" },
      { label: "Consultant", value: "JN020" },
      { label: "Customer Service", value: "JN003" },
      { label: "Design", value: "JN021" },
      { label: "Distribution - Shipping", value: "JN027" },
      { label: "Education", value: "JN031" },
      { label: "Engineering", value: "JN004" },
      { label: "Entry Level", value: "JN022" },
      { label: "Executive", value: "JN018" },
      { label: "Facilities", value: "JN017" },
      { label: "Finance", value: "JN005" },
      { label: "Franchise", value: "JN060" },
      { label: "General Business", value: "JN006" },
      { label: "General Labor", value: "JN051" },
      { label: "Government", value: "JN046" },
      { label: "Government - Federal", value: "JN070" },
      { label: "Grocery", value: "JN055" },
      { label: "Health Care", value: "JN023" },
      { label: "Hospitality - Hotel", value: "JN040" },
      { label: "Human Resources", value: "JN007" },
      { label: "Information Technology", value: "JN008" },
      { label: "Installation - Maint - Repair", value: "JN056" },
      { label: "Insurance", value: "JN034" },
      { label: "Inventory", value: "JN015" },
      { label: "Legal", value: "JN030" },
      { label: "Legal Admin", value: "JN041" },
      { label: "Management", value: "JN037" },
      { label: "Manufacturing", value: "JN029" },
      { label: "Marketing", value: "JN009" },
      { label: "Media - Journalism - Newspaper", value: "JN047" },
      { label: "Nonprofit - Social Services", value: "JN058" },
      { label: "Nurse", value: "JN050" },
      { label: "Other", value: "JN010" },
      { label: "Pharmaceutical", value: "JN049" },
      { label: "Professional Services", value: "JN024" },
      { label: "Purchasing - Procurement", value: "JN016" },
      { label: "QA - Quality Control", value: "JN025" },
      { label: "Real Estate", value: "JN057" },
      { label: "Research", value: "JN026" },
      { label: "Restaurant - Food Service", value: "JN035" },
      { label: "Retail", value: "JN033" },
      { label: "Sales", value: "JN011" },
      { label: "Science", value: "JN012" },
      { label: "Skilled Labor - Trades", value: "JN013" },
      { label: "Strategy - Planning", value: "JN028" },
      { label: "Supply Chain", value: "JN014" },
      { label: "Telecommunications", value: "JN048" },
      { label: "Training", value: "JN032" },
      { label: "Transportation", value: "JN044" },
      { label: "Veterinary Services", value: "JN069" },
      { label: "Warehouse", value: "JN045" }
    ],
  },
  {
    title: "Relocation Filter",
    placeholder: "Select Relocation Filter",
    alias: "RelocationFilter",
    type:"select",
    options: [
      { label: "Relocate to Specified State", value: "RS" },
{ label: "Relocate to Specified City", value: "RC" },
{ label: "Relocate to Specified Nation", value: "RN" },
{ label: "Relocate to Any Location", value: "RA" } 
    ],
  },
  {
    title: "Search Radius in Miles",
    placeholder: "Select Search Radius in Miles",
    alias: "SearchRadiusInMiles",
    type:"select",
    options: [
        { label: "0 Mile", value: "0" },
  { label: "1 Mile", value: "1" },
  { label: "2 Miles", value: "2" },
  { label: "3 Miles", value: "3" },
  { label: "4 Miles", value: "4" },
  { label: "5 Miles", value: "5" },
  { label: "10 Miles", value: "10" },
  { label: "15 Miles", value: "15" },
  { label: "20 Miles", value: "20" },
  { label: "25 Miles", value: "25" },
  { label: "30 Miles", value: "30" },
  { label: "40 Miles", value: "40" },
  { label: "50 Miles", value: "50" },
  { label: "75 Miles", value: "75" },
  { label: "100 Miles", value: "100" },
  { label: "125 Miles", value: "125" },
  { label: "150 Miles", value: "150" },
    ],
  },
  {
    title: "Freshness in Days",
    placeholder: "Select Freshness in Days",
    alias: "FreshnessInDays",
     type:"select",
    options: [
      { label: "Today", value: "0" },
      { label: "yesterday", value: "1" },
      { label: "last 7 days", value: "7" },
      { label: "last 30 days", value: "30" },
      { label: "last 90 days", value: "90" },
      { label: "last 180 days", value: "180" },
      { label: "last 270 days", value: "270" },
      { label: "last year", value: "365" },
      { label: "last 3 years", value: "1095" },
      { label: "last 5 years", value: "1825" },
      { label: "last 10 years", value: "3650" },
      { label: "last 15 years", value: "5475" },
      { label: "last 20 years", value: "7300" },
    ],
  },
  {
    title: "Employment Type",
    placeholder: "Select Employment Type",
    alias: "EmploymentType",
     type:"select",
    options: [
      { label: "All combinations", value: "All" },
      { label: "Fill-Time employee", value: "ETFE" },
      { label: "Part-Time employee", value: "ETPE" },
      { label: "Contractror", value: "ETCT" },
      { label: "Intern", value: "ETIN" },
    ],
  },
  {
    title: "Minimum Travel Requirement",
    placeholder: "Select Minimum Travel Requirement",
    alias: "MinimumTravelRequirement",
     type:"select",
    options: [
      { label: "NONE", value: "RTNONE" },
      { label: "Neglibile", value: "RT3210" },
      { label: "up to 25%", value: "RT321" },
      { label: "up to 50%", value: "TR32" },
      { label: "ROad wrrior", value: "RT" },
    ],
  },
  {
    title: "Minimum Degree",
    placeholder: "Select Minimum Degree",
    alias: "MinimumDegree",
     type:"select",
    options: [
      { label: "High school", value: "CE31" },
      { label: "2YEAR degree", value: "CE32" },
      { label: "4YEAR degree", value: "CE321" },
      { label: "Graduate degree", value: "CE3210" },
    ],
  },
  {
    title: "Compensation Type",
    placeholder: "Select Compensation Type",
    alias: "CompensationType",
     type:"select",
    options: [
      { label: "salary", value: "SALR" },
      { label: "Hourly", value: "HOUR" },
    ],
  },
  {
    title: "Minimum Salary",
    placeholder: "Enter Minimum Salary",
    alias: "MinimumSalary",
     type:"text",
  },
  {
    title: "Maximum Salary",
    placeholder: "Enter Maximum Salary",
    alias: "MaximumSalary",
    type:"text",
  },
  {
    title: "Exclude Resumes with No Salary",
    placeholder: "Exclude Resumes with No Salary",
    alias: "ExcludeResumesWithNoSalary",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "NO", value: "No" },
    ],
     type:"select",
  },
  {
    title: "Language Spoken",
    placeholder: "Language Spoken",
    alias: "LanguagesSpoken",
     type:"multiSelect",
    options: [
      { label: "English", value: "LAEN" },
      { label: "Catalán", value: "LACA" },
      { label: "Chinese-Mandarin", value: "LAZH" },
      { label: "Czech", value: "LACS" },
      { label: "Danish", value: "LADA" },
      { label: "Dutch", value: "LANL" },
      { label: "Estonian", value: "LAET" },
      { label: "Euskera", value: "LAEU" },
      { label: "Finnish", value: "LAFI" },
      { label: "French", value: "LAFR" },
      { label: "German", value: "LADE" },
      { label: "Greek", value: "LAEL" },
      { label: "Hebrew", value: "LAHE" },
      { label: "Hungarian", value: "LAHU" },
      { label: "Icelandic", value: "LAIS" },
      { label: "Italian", value: "LAIT" },
      { label: "Japanese", value: "LAJA" },
      { label: "Korean", value: "LAKO" },
      { label: "Latvian", value: "LALV" },
      { label: "Lithuanian", value: "LALT" },
      { label: "Norwegian", value: "LANO" },
      { label: "Polish", value: "LAPL" },
      { label: "Spanish", value: "LAES" },
      { label: "Portuguese", value: "LAPT" },
      { label: "Romanian", value: "LARO" },
      { label: "Russian", value: "LARU" },
      { label: "Swedish", value: "LASV" },
      { label: "Arabic", value: "LAAR" },
      { label: "Bengali", value: "LABN" },
      { label: "Chinese-Cantonese", value: "LAHK" },
      { label: "Chinese-Taiwanese", value: "LATW" },
      { label: "Hindi", value: "LAHI" },
      { label: "Urdu", value: "LAUR" },
      { label: "Armenian", value: "LAHY" },
      { label: "Assamese", value: "LAAS" },
      { label: "Farsi", value: "LAFO" },
      { label: "Gujarati", value: "LAGU" },
      { label: "Kannada", value: "LAKN" },
      { label: "Kashmiri", value: "LAKS" },
      { label: "Malayalam", value: "LAML" },
      { label: "Oriya", value: "LAOR" },
      { label: "Pashto", value: "LAPS" },
      { label: "Punjabi", value: "LAPA" },
      { label: "Sanskrit", value: "LASA" },
      { label: "Sindhi", value: "LASD" },
      { label: "Tamil", value: "LATA" },
      { label: "Telugu", value: "LATE" },
      { label: "Turkish", value: "LATR" },
      { label: "Uzbek", value: "LAUZ" },
      { label: "Indonesian", value: "LAFJ" },
      { label: "Vasco", value: "LAVA" },
      { label: "Bulgarian", value: "LABU" },
      { label: "Croatian", value: "LACR" },
      { label: "Macedonian", value: "LAMC" },
      { label: "Serbian", value: "LASB" },
      { label: "Albanian", value: "LASQ" },
      { label: "Cambodian", value: "LACM" },
      { label: "Chinese-Chinois", value: "LACH" },
      { label: "Ukranian", value: "LAKR" },
      { label: "Vietnamese", value: "LAVT" }
    ],
  },
  {
    title: "Currently Employed",
    placeholder: "Select Currently Employed",
    alias: "CurrentlyEmployed",
     type:"select",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "NO", value: "No" },
    ],
  },
  {
    title: "Management Experience",
    placeholder: "Select Management Experience",
    alias: "ManagementExperience",
     type:"select",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "NO", value: "No" },
    ],
  },
  {
    title: "Minimum Employees Managed",
    placeholder: "Enter Minimum Employees Managed",
    alias: "MinimumEmployeesManaged",
    type:"text",
  },
  {
    title: "Maximum Commute",
    placeholder: "Enter Maximum Commute",
    alias: "MaximumCommute",
    type:"text",
  },
  {
    title: "Security Clearance",
    placeholder: "Select Security Clearance",
    alias: "SecurityClearance",
     type:"select",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "NO", value: "No" },
    ],
  },
  {
    title: "Exclude VR Resumes",
    placeholder: "Select Exclude VR Resumes",
    alias: "ExcludeIVRResumes",
     type:"select",
    options: [
      { label: "Yes", value: "Yes" },
      { label: "NO", value: "No" },
    ],
  },
  {
    title: "Militery Experience",
    placeholder: "Select Exclude Militery Experience",
    alias: "MilitaryExperience",
     type:"select",
    options: [
      { label: "Active Duty", value: "M1" },
      { label: "Reservist-Drilling", value: "M2" },
      { label: "National Guard-Drilling", value: "M3" },
      { label: "Inactive Reserve", value: "M4" },
      { label: "Inactive National Guard", value: "M5" },
      { label: "Retired Military", value: "M6" },
      { label: "Veteran", value: "M7" }
    ],
  },
  {
    title: "Search Radius in Kilometers",
    placeholder: "Select Search Radius in Kilometers",
    alias: "SearchRadiusInKilometer",
     type:"select",
    options: [
      { label: "0 km", value: "0" },
      { label: "1 km", value: "1" },
      { label: "2 km", value: "2" },
      { label: "3 km", value: "3" },
      { label: "4 km", value: "4" },
      { label: "5 km", value: "5" },
      { label: "10 km", value: "10" },
      { label: "15 km", value: "15" },
      { label: "20 km", value: "20" },
      { label: "25 km", value: "25" },
      { label: "30 km", value: "30" },
      { label: "40 km", value: "40" },
      { label: "50 km", value: "50" },
      { label: "75 km", value: "75" },
      { label: "100 km", value: "100" },
      { label: "125 km", value: "125" },
      { label: "150 km", value: "150" }
    ],
  },
  {
    title: "Apply Last Activity",
    placeholder: "Select Apply Last Activity",
    alias: "ApplyLastActivity",
     type:"select",
    options: [
      { label: "Midnight-Present", value: "0" },
      { label: "Since Yesterday", value: "1" },
      { label: "Last 7 Days", value: "7" },
      { label: "Last 30 Days", value: "30" },
      { label: "Last 90 Days", value: "90" },
      { label: "Last 180 Days", value: "180" },
      { label: "Last 270 Days", value: "270" },
      { label: "Last Year", value: "365" }
    ],
  },
  {
    title: "Search With Most Recent Job Title",
    placeholder: "Select Search With Most Recent Job Title",
    alias: "SearchWithMostRecentJobTitle",
     type:"select",
    options: [
      { label: "Include Most Recent Company", value: "True" },
      { label: "Exclude Most Recent Company", value: "False" }
    ],
  },
  {
    title: "Search With Most Recent Comapny",
    placeholder: "Select Search With Most Recent Company",
    alias: "SearchWithMostRecentCompany",
     type:"select",
    options: [
      { label: "Include Most Recent Company", value: "True" },
      { label: "Exclude Most Recent Company", value: "False" }
    ],
  },
  {
    title: "NicheInclusion",
    placeholder: "Select NicheInclusion",
    alias: "NicheInclusion",
     type:"select",
    options: [
      { label: "Search under CareerRookie", value: "CC" },
      { label: "Search under StaffNurse", value: "SF" },
      { label: "Search under Sologig", value: "SG" },
      { label: "Search under CareerBuilder & Sologig, combined", value: "UG" },
      { label: "Search under Miracle Workers", value: "WM" },
      { label: "Search under Work In Retail", value: "WR" },
      { label: "Search under Wounded Warrior", value: "WW" },
      { label: "Search under Recrulex", value: "RX" },
      { label: "Search under Les Jeudis", value: "LJ" },
      { label: "Search under CAO Emplois", value: "CE" },
      { label: "Search under E-recrut", value: "ER" },
      { label: "Search under Job Scout", value: "JS" },
      { label: "Search under Cyprus", value: "CY" }
    ],
  },
  {
    title: "Lemmatize",
    placeholder: "Select Lemmatize",
    alias: "Lemmatize",
     type:"select",
    options: [
      { label: "Do not use lemmatization", value: "False" },
      { label: "Use lemmatization", value: "True" }
    ],
  },
];
